import React, { useEffect, useState } from "react";
import MoneyIcon from "../assets/icons/money.svg";
import { useTranslation } from "react-i18next";
import { userInfo } from "../web3";

function QuestCard({ questItem }: any) {

    const { t } = useTranslation();


    return (
        <div className="quests_card">
            <div className="quests_card__header">
                <div className="quests_card__header___left">
                    <img src={questItem.icon} alt="icon" width={32} height={32} />
                    <div className="quests_card__header___left____task">
                        <div className="quests_card__header___left____task_____title">
                            {t(questItem.name)}
                        </div>
                        <div className="quests_card__header___left____task_____count">
                            {questItem.count}/{questItem.allCount}
                        </div>
                    </div>
                </div>
                <div className="quests_card__header___right">
                    {questItem.earning}
                </div>
            </div>
            <div className="quests_card__bottom">
                <span className="quests_card__bottom___text">
                    <img src={MoneyIcon} alt="icon" width={24} height={24} />
                    {t('Заработано')}: {questItem.allEarning} USDT
                </span>
                <div>
                    {questItem.lvl !== undefined && (
                        <div className="quests_card__bottom">
                            <span className="quests_card__bottom___text">
                                {t('УРВ')} -  {questItem.lvl}
                            </span>
                        </div>
                    )}
                </div>
            </div>


        </div>

    )
}

export default QuestCard
